import { AppButton } from 'components';
import useToaster from 'hooks/useToaster';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useSubjects from 'hooks/API/GET/useSubjects';
import useManageSubjects from 'hooks/API/useManageSubjects';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import useDeleteSubject from 'hooks/API/DELETE/useDeleteSubject';
import TablePaginate from '../../components/Paginate';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { Link } from 'react-router-dom';

function MainSubjects() {
  const history = useHistory();
  const [params, setParams] = usePaginateDefaults();
  const { isLoading, data, isError } = useSubjects({
    enabled: true,
    configs: { params },
  });
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const deleteAPIObject = useDeleteSubject();

  const { meta: { page, total } = {} } = data?.data ?? {};

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
  }

  return (
    <>
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete subject"
        handleConfirmation={() => {
          if (deleteAPIObject.isLoading) return;

          deleteAPIObject.mutate(deleteSModal?.data?._id);
          closeSModal();
        }}
      />
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={() => history.push('/curriculum')}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Curriculum', to: '/curriculum' },
                ]}
                current="Subjects"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">Manage Subjects</h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Subjects..."
                          type="text"
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="flex items-center gap-10">
                    <Link to="/manage/subjects/add">
                      <button className="btn-left-content add">Add Subject</button>
                    </Link>
                  </div>
                </div>

                <div className="tableWrap">
                  <div className="table-responsive">
                    <table className="table tableWrap__table">
                      <thead className="thead-light __appTheadColor">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col" className="w40">
                            Name
                          </th>
                          <th scope="col" className="w40">
                            Unique key
                          </th>
                          <th scope="col" className="align-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <tbody>
                          <tr>
                            <td>Loading...</td>
                          </tr>
                        </tbody>
                      ) : isError ? (
                        <tbody>
                          <tr>
                            <td>Failed to load data</td>
                          </tr>
                        </tbody>
                      ) : data?.data?.result?.length > 0 ? (
                        <tbody>
                          {data?.data?.result?.map((result, index) => {
                            return (
                              <tr key={result._id}>
                                <th scope="row">{index + 1}</th>
                                <td>{result.name}</td>
                                <td>{result.key}</td>
                                <td className="align-center">
                                  <AppButton
                                    className="actions-icons mx-2 text-primary"
                                    onClick={() => {
                                      history.push(`/manage/subjects/edit/${result._id}`);
                                    }}
                                    title="Edit"
                                  >
                                    <img src={AppPics.EditSvg} alt="edit this option" />
                                  </AppButton>

                                  <AppButton
                                    className="actions-icons mx-2 text-danger"
                                    onClick={() => {
                                      handleDeleteSModal({ show: true, data: result });
                                    }}
                                    title="Delete"
                                  >
                                    <img src={AppPics.DeleteSvg} alt="delete this option" />
                                  </AppButton>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td>No records found</td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
                <TablePaginate
                  maxCount={total}
                  currentPage={page}
                  defaultLimit={params.limit}
                  setPage={(page) => setParams((x) => ({ ...x, page }))}
                  handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainSubjects;
